import { createAction } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { Reducers } from '@sda/enums/store';
import { setLoaderIsFinishedError, setLoaderIsFinishedSuccess, setLoaderIsLoading } from '@client/slices/helpers/loaders.reducer';
import { showSnackbar } from '@client/listeners/lib/snackbar';
import { batch } from '@client/hooks/redux.hooks';
import { updateAct } from '@client/slices/entities/acts.reducer';
import { trackAnalytics } from '@client/intercom';
import { getSelectedProfile } from '@client/selectors/helpers/profile';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';
import type { AddListener } from '@client/listeners/lib';

export const startSaveArtistInfo = createAction<{ bioHTML: string }>(`${Reducers.ACTS}/startSaveArtistInfo`);

export const signupArtistInfoListeneners = (addListener: AddListener) => [
  addListener({
    actionCreator: startSaveArtistInfo,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState();
      const { dispatch } = listenerApi;
      const firebase = window.Firebase;

      const scope = 'signup-act-info-form';
      dispatch(setLoaderIsLoading(scope));

      try {
        const { id, profileType, publicImageUrl } = getSelectedProfile(state);

        await firebase.SDK.Acts.propagate(id, action.payload);

        batch(() => {
          dispatch(updateAct({ id, changes: action.payload }));
          dispatch(setLoaderIsFinishedSuccess(scope));
        });

        trackAnalytics(startSaveArtistInfo);

        if (!isEmpty(publicImageUrl)) {
          trackAnalytics(AnalyticsEvents.COMPLETED_PROFILE, {
            profileType,
          });
        }
      } catch (e) {
        showSnackbar(e);
        dispatch(setLoaderIsFinishedError(scope, e));
      }
    },
  }),
];
